// extracted by mini-css-extract-plugin
export var parcelRow = "_vh-0";